export default __webpack_public_path__ + "static/media/minsal-uso-racional.636c2946.png";